import React from "react"

import { useNavigate } from "react-router-dom"

import PageContents from "components/PageContents"

import * as F from "tsui/Form"
import * as AuthApi from "api/auth"

interface LoginPageProps {
    return?: string
}

export default function LoginPage(props: LoginPageProps) {
    const buttonRef = React.useRef<HTMLButtonElement | null | undefined>()

    const [errorMessage, setErrorMessage] = React.useState<string | undefined>(
        undefined
    )

    const form = F.useInputForm()
    const navigate = useNavigate()

    const onSubmit = React.useCallback((evt: F.InputFormEvent) => {
        //console.log("on submit")

        if (form.error) return

        form.setBusy()

        AuthApi.login(evt.data)
            .then((sess) => {
                // console.log(evt.data)

                form.clearBusy()
                // navigate(props.return ?? '/');
                navigate(props.return ?? "/admin")
            })
            .catch((err) => form.setError(err))
    }, [])

    return (
        <PageContents title="Login">
            <F.PageForm title="Login" onSubmit={onSubmit} form={form} size="sm">
                <F.InputText
                    label="Email"
                    id="login"
                    autocomplete="username"
                    validate="email"
                    required
                    form={form}
                    xsMax
                />
                <F.InputText
                    label="Password"
                    id="password"
                    type="password"
                    autocomplete="current-password"
                    required
                    validate="not-empty"
                    form={form}
                    xsMax
                />

                <F.InputCheckbox
                    id="rememberMe"
                    label="Remember Me"
                    value={false}
                    data={false}
                    form={form}
                    xsMax
                />

                <F.SubmitButton label="Sign In" form={form} xsMax />

                <F.NavigateLink
                    label="Register new account"
                    href="/join"
                    form={form}
                    xsMax
                    mt={2}
                />
                <F.NavigateLink
                    prefix="forgot"
                    label="login or password?"
                    href="/forgot"
                    form={form}
                    xsMax
                    size="sm"
                    align="right"
                />
            </F.PageForm>
        </PageContents>
    )
}
